import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, Unique, UpdateDateColumn, VersionColumn } from "typeorm";
import { HarvestTypes, PlantsEnum, SupplierTypeEnum } from '@gtpl/shared-models/common-models';
import { CommissionType, HarvestingTime } from '@gtpl/shared-models/raw-material-procurement';
import { IndentItems } from "./indent-items.entity";
@Entity("indent")
export class Indent {
    @PrimaryGeneratedColumn("increment", { name: 'indent_id' })
    indentId: number;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "indent_code"
    })
    indentCode: string;

    @Column({
        nullable: false,
        name: "indent_date"
    })
    indentDate: Date;

    @Column({
        type: 'enum',
        enum: SupplierTypeEnum,
        nullable: false,
        default: SupplierTypeEnum.FARMER,
        name: 'supplier_type'
    })
    supplierType: SupplierTypeEnum;

    

    @Column({
        type: 'enum',
        enum: CommissionType,
        nullable: false,
        default: CommissionType.PERCENTAGE,
        name: 'commission_type'
    })
    commissionType: CommissionType;  

    @Column("int", {
        nullable: false,
        name: "commission"
    })
    commission: number;

    @Column({
        nullable: false,
        name: "harvesting_date"
    })
    harvestingDate: Date;

    @Column({
        type: 'enum',
        enum: HarvestingTime,
        nullable: false,
        default: HarvestingTime.MORNING,
        name: 'harvesting_time'
    })
    harvestingTime: HarvestingTime;    
    @Column("int", {
        nullable: false,
        name: "indent_by"
    })
    indentBy: number;  

    @Column("int", {
        nullable: false,
        name: "assign_lead_1"
    })
    assignLead1: number;

    @Column("int", {
        nullable: false,
        name: "assign_lead_2"
    })
    assignLead2: number;

    @Column("boolean", {
        nullable:false,
        default:false,
        name: "vehicle_assigned"
      })
    vehicleAssigned: boolean;

    @Column("boolean", {
        nullable:false,
        default:false,
        name: "grn_completed"
      })
    grnCompleted: boolean;

    @Column({
        type: 'int',
        nullable: true,
        default: 0,
        name: 'plant_id'
    })
    plantId: number;

    @Column("boolean", {
        nullable:false,
        // default:false,
        name: "is_vehicle_required"
      })
      isVehicleRequired: boolean;

    @Column({
    type: 'enum',
    nullable: false,
    enum: HarvestTypes,
    name: "harvest_type"
    })
    harvestType: HarvestTypes;


    @Column("boolean",{
        nullable:false,
        default:true,
        name:"is_active"
    })
    isActive:boolean;

    @CreateDateColumn({ name: "created_at" })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        length: 40,
        default: 'Admin',
        name: "created_user"
    })
    createdUser: string | null;

    @UpdateDateColumn({ name: "updated_at" })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
    @OneToMany(type => IndentItems, indentItems => indentItems.indentInfo, { cascade: true })
    indentItemsInfo: IndentItems[];
}

